import React, { createContext, Context, useState, useEffect } from 'react'
import { IMaintenance } from 'selfServicePortal/interfaces/i-api-support'
import { waitForLanguage, getMarket } from 'shared/utils/helpers'
import { logError } from 'shared/AppInsight'
import Axios from 'axios'
import { apiRoutes } from '../../selfServicePortal/constants/routes'
import MaintenanceWindow from '../components/MaintenanceWindow/MaintenanceWindow'
import appConfig from 'app.config'

const transportWithCredentials = Axios.create({})
transportWithCredentials.interceptors.request.use(async (config) => {
	config.headers['Accept-Language'] = await waitForLanguage()
	return config
})

interface IMaintenanceContext {
	maintenanceData: IMaintenance | undefined
	setMaintenanceData: Function
}

const MaintenanceContext: Context<IMaintenanceContext> =
	createContext<IMaintenanceContext>({
		maintenanceData: undefined,
		setMaintenanceData: () => {},
	})

export function MaintenanceContextProvider() {
	const [maintenanceData, setMaintenanceData] = useState<IMaintenance>()

	const maintenanceInfo = {
		async getMaintenanceInfo() {
			const response = await transportWithCredentials
				.get<IMaintenance>(apiRoutes.getMaintenanceInfo(getMarket()!))
				.then((result) => {
					if (result.status === 204) return undefined
					return result.data as IMaintenance
				})
				.catch((err) => {
					logError(err)
					if (err.response?.status === 404) {
						throw new Error(
							'There is no maintenancedata for chosen market',
						)
					} else {
						throw err
					}
				})
			return response as IMaintenance
		},
	}
	const getMaintenanceInfo = async () => {
		try {
			let data = await maintenanceInfo.getMaintenanceInfo()
			if (data !== undefined) setMaintenanceData(data)
		} catch (error) {
			console.log(error)
		}
	}

	useEffect(() => {
		async function checkMaintenanceInfo() {
			if (await maintenanceInfo) {
				getMaintenanceInfo()
			}
		}
		checkMaintenanceInfo()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{maintenanceData &&
				maintenanceData.affectedMarkets.includes(appConfig.country) && (
					<MaintenanceContext.Provider
						value={{ maintenanceData, setMaintenanceData }}>
						<MaintenanceWindow />
					</MaintenanceContext.Provider>
				)}
		</>
	)
}

export default MaintenanceContext
